export enum AllBonusTypes {
  NoDeposit = 3,
  Cashback = 4,
  CasinoWelcome = 5,
  Reload = 6,
  FreeSpins = 7,
  SportsWelcome = 10,
  RiskFreeBetBonus = 11,
  SportsReload = 13,
  PersonalizedRiskFreeBetBonus = 16,
  SportsNoDeposit = 18,
  ManualCashback = 19,
  GenericFreeSpins = 20,
  SportsManualCashback = 21,
}
